import { zodResolver } from '@hookform/resolvers/zod'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { FormProvider, useForm } from 'react-hook-form'
import { PostBookingAmendPayloadSchema } from '@/schemas/booking'
import { getBookingQueryOptions } from '@/queries/query'

export const Route = createFileRoute('/my-booking/$id/amend')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const isAuthenticated = Route.useRouteContext({
    select: (s) => s.authContext.isAuthenticated,
  })
  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))
  const form = useForm<PostBookingAmendPayloadSchema>({
    mode: 'all',
    resolver: zodResolver(PostBookingAmendPayloadSchema),
    defaultValues: {
      id: bookingId,
      booked_transportation_ids: [],
      ...(isAuthenticated && booking.contact_email
        ? { contact_email: booking.contact_email }
        : {}),
    },
  })

  return (
    <FormProvider {...form}>
      <Outlet />
    </FormProvider>
  )
}
